module.exports = __webpack_public_path__ + "static/media/GitHub.cefc2023.png";


//////////////////
// WEBPACK FOOTER
// ./src/GitHub.png
// module id = 294
// module chunks = 0